import React from 'react';

const LeftSideLayout2 = () => {
	return <></>;
};

export default React.memo(LeftSideLayout2);
